import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setUpdateDurationSource,
  UPDATE_DURATION_SOURCE,
  updateDurationSourceSelector,
} from 'features/courseResume';
import Field from 'components/Field';
import RadioInput from 'components/RadioInput';

function UpdateDurationSourceField() {
  const dispatch = useDispatch();
  const source = useSelector(updateDurationSourceSelector);

  const handleSourceChange = useCallback(
    (e) => {
      dispatch(setUpdateDurationSource(e.target.value));
    },
    [dispatch]
  );

  return (
    <Field
      label="Select Source"
      labelClassName="h4 normal"
      className="m-b-m"
    >
      <RadioInput
        value={UPDATE_DURATION_SOURCE.scaler}
        isChecked={source === UPDATE_DURATION_SOURCE.scaler}
        onChange={handleSourceChange}
      >
        Scaler
      </RadioInput>
      <RadioInput
        value={UPDATE_DURATION_SOURCE.learner}
        isChecked={source === UPDATE_DURATION_SOURCE.learner}
        onChange={handleSourceChange}
      >
        Learner
      </RadioInput>
    </Field>
  );
}

export default UpdateDurationSourceField;
